import { useEffect } from "react";

type UseAppSidebarWidthCssVarOptions = {
  isDocked: boolean;
  sidebarCollapsed: boolean;
};

export function useAppSidebarWidthCssVar({
  isDocked,
  sidebarCollapsed,
}: UseAppSidebarWidthCssVarOptions): void {
  useEffect(() => {
    const root = document.documentElement;

    if (!isDocked) {
      root.style.setProperty("--app-sidebar-current-width", "0px");
      return;
    }

    const variableName = sidebarCollapsed
      ? "--sidebar-width-collapsed"
      : "--sidebar-width-expanded";
    const fallback = sidebarCollapsed ? "60px" : "252px";
    const width =
      getComputedStyle(root).getPropertyValue(variableName).trim() || fallback;
    root.style.setProperty("--app-sidebar-current-width", width);
  }, [isDocked, sidebarCollapsed]);
}
